import memoize from "fast-memoize";
import fetch from "./fetch-trade-api";

export const TRUCK_REGEX = /(\w+) TRUCK/;
export const trimTruckString = str => (TRUCK_REGEX.exec(str)[1] || "").trim();

const makes = memoize(
  async ({ yearId }) => {
    const resp = await fetch(`/v1/report/makes/year/${yearId}`);
    const makes = await resp.json();

    const truckMakeLabelToId = new Map();
    const makesLabelToId = new Map();
    const makesMap = new Map();

    for (let makeId in makes) {
      const makeLabel = makes[makeId];
      if (TRUCK_REGEX.test(makeLabel)) {
        const truckMake = trimTruckString(makeLabel);
        truckMakeLabelToId.set(truckMake, makeId);
        if (makesLabelToId.has(truckMake)) {
          makesMap.set(makeId, truckMake);
          makesMap.set(`${makesLabelToId.get(truckMake)}-${makeId}`, truckMake);
        }
      } else {
        if (truckMakeLabelToId.has(makeLabel)) {
          makeId = `${makeId}-${truckMakeLabelToId.get(makeLabel)}`;
        }
        makesLabelToId.set(makeLabel, makeId);
        makesMap.set(makeId, makeLabel);
      }
    }
    return makesMap;
  },
  {
    serializer: ({ yearId }) => yearId
  }
);

export const label = async ({ yearId, makeId }) => {
  const map = await makes({ yearId });
  return map.get(makeId);
};

export default makes;
